import React, { useEffect, useState } from 'react';
import './WhatsNew.css';
import { useApi } from '../ApiContext';
import { useAuth } from '../AuthContext';
import axios from 'axios';

export default function WhatsNew() {
  const { API_BASE_URL } = useApi();
  const { userType } = useAuth();

  const [newsList, setNewsList] = useState([]);
  const [newTitle, setNewTitle] = useState('');
  const [newContent, setNewContent] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(false);

  const isAdmin = userType === 'Admin';

  // Fungsi Parser dengan Regex yang stabil
  const formatWhatsAppStyle = (text) => {
    if (!text) return '';
    return text
      .replace(/\n/g, '<br />')
      .replace(/```([\s\S]*?)```/g, '<code style="background: #f4f4f4; padding: 2px 6px; border-radius: 4px; font-family: monospace;">$1</code>')
      .replace(/\*(.*?)\*/g, '<strong>$1</strong>')
      .replace(/_(.*?)_/g, '<em>$1</em>')
      .replace(/~(.*?)~/g, '<del>$1</del>');
  };

  const fetchNews = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_BASE_URL}/whatsnew`);
      setNewsList(res.data);
    } catch (err) {
      console.error('Error fetching news:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNews();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newTitle.trim() || !newContent.trim()) {
      alert('Please fill in both title and content.');
      return;
    }
    try {
      const payload = { userType, title: newTitle, content: newContent };
      if (editingId) {
        await axios.put(`${API_BASE_URL}/whatsnew/${editingId}`, payload);
        alert('News updated successfully!');
      } else {
        await axios.post(`${API_BASE_URL}/whatsnew`, payload);
        alert('News added successfully!');
      }
      setNewTitle('');
      setNewContent('');
      setEditingId(null);
      fetchNews();
    } catch (err) {
      console.error('Error saving news:', err);
      alert('Failed to save news.');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this post?')) return;
    try {
      await axios.delete(`${API_BASE_URL}/whatsnew/${id}`, { data: { userType } });
      alert('News deleted successfully!');
      fetchNews();
    } catch (err) {
      console.error('Error deleting news:', err);
      alert('Failed to delete news.');
    }
  };

  const handleEdit = (item) => {
    setEditingId(item.id);
    setNewTitle(item.title);
    setNewContent(item.content);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="wn-container">
      <h1 className="wn-title">📰 What's New</h1>
      {isAdmin && (
        <form className="wn-form" onSubmit={handleSubmit}>
          <h2>{editingId ? 'Edit Post' : 'Add New Post'}</h2>
          <input
            type="text"
            placeholder="Enter title (Supports *Bold*, _Italic_)"
            value={newTitle}
            onChange={(e) => setNewTitle(e.target.value)}
            className="wn-input"
          />
          <textarea
            rows="10"
            placeholder="Content (Supports *Bold*, _Italic_, ~Potong~, ```Monospace```)"
            value={newContent}
            onChange={(e) => setNewContent(e.target.value)}
            className="wn-textarea"
          />
          <div className="wn-btn-group">
            <button type="submit" className="wn-btn wn-btn-primary">
              {editingId ? 'Update' : 'Add'}
            </button>
            {editingId && (
              <button
                type="button"
                className="wn-btn wn-btn-cancel"
                onClick={() => {
                  setEditingId(null);
                  setNewTitle('');
                  setNewContent('');
                }}
              >
                Cancel
              </button>
            )}
          </div>
        </form>
      )}
      {loading ? (
        <p className="wn-loading">Loading...</p>
      ) : (
        <div className="wn-list">
          {newsList.length === 0 ? (
            <p className="wn-empty">No updates yet.</p>
          ) : (
            newsList.map((item) => (
              <div key={item.id} className="wn-item">
                <div className="wn-header">
                  {/* TITLE SEKARANG DAH SUPPORT WHATSAPP FONT */}
                  <h3 
                    className="wn-item-title" 
                    dangerouslySetInnerHTML={{ __html: formatWhatsAppStyle(item.title) }} 
                  />
                  {isAdmin && (
                    <div className="wn-actions">
                      <button className="wn-btn wn-btn-edit" onClick={() => handleEdit(item)}>Edit</button>
                      <button className="wn-btn wn-btn-delete" onClick={() => handleDelete(item.id)}>Delete</button>
                    </div>
                  )}
                </div>
                <div 
                  className="wn-content" 
                  dangerouslySetInnerHTML={{ __html: formatWhatsAppStyle(item.content) }} 
                />
                <p className="wn-date">
                  🕒 Posted on: {new Date(item.created_at || item.createdAt).toLocaleString()}
                </p>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}